import { Component } from '@opten/compiler/metadata/component';
import Slider from '@opten/slider';
import SliderDotsResponsiveBehavior from '@opten/slider/dots-responsive-behavior';
import { ISliderOptions } from '@opten/slider';

@Component({ className: 'js-news-slider' })
export class NewsSliderComponent {
	private slider: Slider;

	constructor(private element: HTMLElement) {
		// const behaviors = [new SliderDotsResponsiveBehavior()];

		// const options: ISliderOptions = {
		// 	slidesToScroll: 1
		// };

		// this.slider = new Slider(element, options, behaviors);
		const frame = this.element.querySelector('.js-frame');
		const pagination = this.element.querySelector('.js-dots');
		const instance = new Swiper(frame, {
			pagination: {
				el: pagination,
				type: 'bullets',
				clickable: true,
				bulletElement: 'li'
			},
			spaceBetween: 0,
			slidesPerView: 2,
			breakpoints: {
				320: {
					slidesPerView: 1
				},
				767: {
					slidesPerView: 2
				},
				992: {
					slidesPerView: 3
				}
			}
		});
	}
}
